const PLATFORMS = {
    WEB: 'ingameShop',
    STEAM: 'steam',
    WIN_STORE: 'winstore',
    EGS: 'egs',
};
const DWH_PLATFORMS = {
    [PLATFORMS.WEB]: 'web',
    [PLATFORMS.STEAM]: 'steam',
    [PLATFORMS.WIN_STORE]: 'winstore',
    [PLATFORMS.EGS]: 'egs',
};

export { DWH_PLATFORMS, PLATFORMS };
//# sourceMappingURL=platforms.js.map
